(<template>
  <div class="autocomplete">
    <sk-input :id="id"
              :description="description"
              :placeholder="placeholder"
              :preselected-value="preselectedValue"
              :input-icon="'search'"
              :class="[className]"
              :validation-name="validationName"
              :disabled="disabled"
              :autofocus="autofocus"
              @fieldvaluechanged="valueChanged" />
    <ul v-if="suggestions.length"
        class="autocomplete-list">
      <li v-for="(suggestion, index) in suggestions"
          :key="index"
          class="autocomplete-item"
          @click="selectSuggestion(suggestion)">
        {{ suggestion.formatted_address }}
      </li>
    </ul>
  </div>
</template>)
<script>
  export default {
    props: {
      description: {
        type: String,
        default: ''
      },
      validationName: {
        type: String, // connects with ErrorsStorage
        default: ''
      },
      preselectedValue: {
        type: [String, Number],
        required: true
      },
      placeholder: {
        type: String,
        default: ''
      },
      id: {
        type: [Number, String],
        default: ''
      },
      className: {
        type: String,
        default: ''
      },
      disabled: Boolean,
      autofocus: {
        type: Boolean,
        default: false
      },
      isGlobal: { // defines if the search is in Norway or Global
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        suggestions: [],
        debounceTimeout: null
      };
    },
    methods: {
      valueChanged(value) {
        clearTimeout(this.debounceTimeout);
        this.$emit('valuechanged', value);

        if (!value) {
          this.suggestions = [];
          return;
        }

        this.debounceTimeout = setTimeout(() => {
          const params = {query: value};
          if (!this.isGlobal) {
            params.region = 'NO';
          }

          this.$store.dispatch('FullAddressStore/fetchAddressList', params)
            .then((response) => {
              this.suggestions = (response || []).map((item) => item.data);
            })
            .catch(() => {
              this.suggestions = [];
            });
        }, 400);
      },
      selectSuggestion(suggestion) {
        this.$emit('placechanged', suggestion);
        this.suggestions = [];
      }
    }
  };
</script>

<style scoped>
.autocomplete {
  position: relative;
  margin-bottom: 10px;
}

.autocomplete-list {
  position: absolute;
  top: 50px;
  right: 0;
  left: 0;
  z-index: 10;
  overflow-y: auto;
  max-height: 200px;
  margin: 4px 0 0 0;
  padding: 0;
  border: 1px solid #ccc;
  background: white;
  list-style: none;
}

.autocomplete-item {
  padding: 6px 10px;
  cursor: pointer;
}

.autocomplete-item:hover {
  background-color: #f0f0f0;
}
</style>
